/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ActionHistoryElementResponse,
    ActionHistoryElementResponseFromJSON,
    ActionHistoryElementResponseFromJSONTyped,
    ActionHistoryElementResponseToJSON,
} from './ActionHistoryElementResponse';

/**
 * 
 * @export
 * @interface ActionHistoryResponse
 */
export interface ActionHistoryResponse {
    /**
     * 
     * @type {Array<ActionHistoryElementResponse>}
     * @memberof ActionHistoryResponse
     */
    elements: Array<ActionHistoryElementResponse>;
    /**
     * 
     * @type {number}
     * @memberof ActionHistoryResponse
     */
    totalElementCount: number | null;
}

export function ActionHistoryResponseFromJSON(json: any): ActionHistoryResponse {
    return ActionHistoryResponseFromJSONTyped(json, false);
}

export function ActionHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionHistoryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': ((json['elements'] as Array<any>).map(ActionHistoryElementResponseFromJSON)),
        'totalElementCount': json['totalElementCount'],
    };
}

export function ActionHistoryResponseToJSON(value?: ActionHistoryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': ((value.elements as Array<any>).map(ActionHistoryElementResponseToJSON)),
        'totalElementCount': value.totalElementCount,
    };
}

